var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('div',{staticClass:"frame"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(("00" + _vm.value).slice(-2)))])]),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }